import { NotificationType } from "@transfr-inc/dashboard-components";

export const handleAwardSelection = (award, link, onError) => {
  if (!link) {
    onError({
      type: NotificationType.error,
      message: `Award link not found for ${award.title}`,
      icon: ["fa-solid", "circle-info"],
    });
    return;
  }
  window.open(link, "_blank");
};

export const handleOpenAllAwards = (links, onError) => {
  if (!links || links.length === 0) {
    onError({
      type: NotificationType.error,
      message: "No awards links found",
      icon: ["fa-solid", "circle-info"],
    });
    return;
  }
  links.forEach((link) => {
    window.open(link, "_blank");
  });
};